import { getAuthBase } from "./getAuthBase";
import { resolvePlatformId } from "./resolvePlatformId";

type PortalOptions = {
  /** Absolute URL the portal redirects back to. Token arrives in its `#` fragment. */
  returnUrl: string;
  /** Active i18n locale, e.g. "en-GB" — normalised to the portal's short form ("en"). */
  language?: string;
  /** Active UI theme. */
  theme?: "light" | "dark";
  /** Open the portal directly on its sign-up view. */
  mode?: "signup";
};

// Tells the ID portal this is a management dashboard (vs the public Client), so
// it shows the dashboard banner copy, hides sign-up, and applies the
// manager-access gate.
//
// It also decides the AUDIENCE of the session the portal hands back: the portal
// defaults `?app=` to `client`, and a `client`-audience token is rejected by
// every dashboard controller (`AppAudienceGuard`, 403 APP_AUDIENCE_MISMATCH).
// Exported so the social-login popup in `AuthContext.provider` sends the same
// value — the two portal entry points drifted once and cost us a prod incident.
export const DASHBOARD_APP_ID = "dashboard";

export const buildPortalUrl = ({ returnUrl, language, theme, mode }: PortalOptions): string => {
  const params = new URLSearchParams();
  params.set("returnUrl", returnUrl);
  params.set("platformId", resolvePlatformId());
  params.set("app", DASHBOARD_APP_ID);
  if (language) params.set("language", language.toLowerCase().split("-")[0]);
  if (theme) params.set("theme", theme);
  if (mode) params.set("mode", mode);

  return `${getAuthBase()}/?${params.toString()}`;
};
